import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Evento } from '../../../models/evento';
import { Ticket } from '../../../models/ticket';

@Component({
  selector: 'app-ticket-resumen-detalle',
  templateUrl: './ticket-resumen-detalle.component.html',
  styleUrls: ['./ticket-resumen-detalle.component.scss']
})
export class TicketResumenDetalleComponent implements OnInit {

  @Input() cita: Evento = null;
  @Input() ticket: Ticket = null;

  @Output() sendToastMsg: EventEmitter<object> = new EventEmitter<object>();

  constructor() { }

  ngOnInit(): void {
  }

  updateToastMsg($event: any) {
    this.sendToastMsg.emit({
      mensajeError: $event.mensajeError,
      mensaje: $event.mensaje,
    });
  }

}
